import {
  FAQS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import logoImage from "public/images/reno_aces/Reno-Aces_2.png";

export const renoaces_pass: TTeamConfig = {
  TEAM_SCHEMA: "renoaces_pass",
  TEAM_FULL_NAME: "Renos Aces",
  BROWSER_TITLE: "Reno Aces Baseball Passes",
  CLIENT_ID: "",
  VENDOR: "TDC",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#002a5c",
    COLORS_SECONDARY: "#d31145",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      HIDE_PASS_DETAILS: true,
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      ADD_SERVICE_FEE_TO_PRICE: true,
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#d31145",
    },

    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    }
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLE_SAVE_CARD: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: `${logoImage.src}?width=96&height=69`,
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Reno%20Aces%20Pass/Pass%20Background_.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    PRE_PURCHASE_FAQS: FAQS,
  },
};
